import React from 'react';
import Layout from '../components/Layout';
import Features from '../components/Features';
import Video from '../components/Video';
import CallToAction from '../components/CallToAction';
import CallToActionTwo from '../components/CallToActionTwo';
import Testimonial from '../components/Testimonial';
import Brands from '../components/Brands';
import Counter from '../components/Counter';
import Faq from '../components/Faq';
import NewsHome from '../components/NewsHome';
import Seo from '../components/Seo';
import BannerTwo from '../components/BannerTwo';

const HomePage = () => (
  <Layout>
    <Seo Sitetitle='Home' />
    <BannerTwo />
    <Features />
    <Video />
    <CallToAction />
    <CallToActionTwo />
    <Testimonial />
    <Brands />
    <Counter />
    <Faq />
    <NewsHome />
  </Layout>
);

export default HomePage;
